module.exports = __webpack_public_path__ + "static/media/icon-shareResource--grey.ff670ab0.svg";